export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/MM-fc20914487571d8ae4a65ecaf586dd2a.png";